import script from "./GlobalGroupsLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupsLoader.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupsLoader.vue?vue&type=style&index=0&id=055e0416&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055e0416"]])

export default __exports__